/**
 * Base API configuration
 * Configures axios instance with base URL and interceptors
 */

import axios from 'axios';
import getEnv from '@/utils/env';
import { oktaAuth } from '@/plugins/okta';

// Base API URL from runtime environment
export const API_BASE_URL = getEnv('BACKEND_URL');

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request interceptor - add Okta auth token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const idToken = oktaAuth.getIdToken();
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
      }
    } catch (error) {
      console.error('Error retrieving Okta token:', error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors globally
apiClient.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.status, error.response?.data);

    // Handle specific error codes
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error('Unauthorized - redirect to login');
          // TODO: Redirect to login when Okta is re-enabled
          break;
        case 403:
          console.error('Forbidden - insufficient permissions');
          break;
        case 404:
          console.error('Resource not found');
          break;
        case 500:
          console.error('Server error');
          break;
        default:
          console.error('API error:', error.response.status);
      }
    } else if (error.request) {
      console.error('No response from server');
    } else {
      console.error('Error setting up request:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
